import DraftNumberInput from "../../../inputs/DraftNumberInput";
import ProductWidgetContainer from "./ProductWidgetContainer";
import styled from "styled-components/macro";

const FlexSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;

const PlatformProductWidget = ({
  product,
  onRemove,
  onProductChange,
  editable,
  baselineProfile,
  deploymentType,
}: any) => {
  const handleProfileChange = (newProfile: string) => {
    const productCopy = { ...product, profile: newProfile };
    onProductChange(productCopy);
  };

  return (
    <ProductWidgetContainer
      onRemove={onRemove}
      title={product.name}
      productKey={product.key}
      canBeRemoved={product.canBeRemoved}
      productProfile={product.profile}
      deploymentType={deploymentType}
      onProfileChange={handleProfileChange}
    >
      <FlexSection>
        <div>
          <DraftNumberInput
            label="Login Per Second"
            product={product}
            field="loginPerSecond"
            baselineProfile={baselineProfile}
            editable={editable}
            onProductChange={onProductChange}
          />
        </div>
        <div>
          <DraftNumberInput
            label="Concurrent Users"
            product={product}
            field="concurrentUsers"
            baselineProfile={baselineProfile}
            editable={editable}
            onProductChange={onProductChange}
          />
        </div>
      </FlexSection>
    </ProductWidgetContainer>
  );
};

export default PlatformProductWidget;
